import styles from "./style/barText.module.css";

const BarText = ({text, percentage}) => {
  return (
    <div className={styles.timerBarCon}>
      <div className={styles.timerBar}>
        <div style={{width: `${percentage}%`}} className={styles.timerDone}></div>
      </div>
      <div className={styles.timerBarText}>
        {text[0]} <b className={styles.percentageCrowd}>{percentage}%</b> {text[1] && text[1]}
      </div>
    </div>
  );
};

export default BarText;
